import script from "./SendHistContent.vue?vue&type=script&lang=js"
export * from "./SendHistContent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__